var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressing-wrapper"},[_c('img',{staticClass:"image-bg",attrs:{"src":require("@/assets/progressing-0.png")}}),_c('img',{staticClass:"image",attrs:{"src":require("@/assets/progressing-1.png")}})])
}]

export { render, staticRenderFns }